import React, { useState, useContext, useEffect } from 'react';
import { Link } from "react-router-dom";
import { AppContext } from './../AppContext'; 

function List() {
	const { themes } = useContext(AppContext);
	return (
		<div>
			<h1>Build-a-Banner&trade;</h1>
			<h3>Confused? You can still use <a href="https://vs-banner-og.netlify.app/">the OG one.</a></h3>
			<div class="List">
				{ themes.map((item, i) => 
					<div key={i} class="ListTile">
						<div>
							<h4>{ item.target }</h4>
							<h5>{ item.desc }</h5>
						</div>
						<div>
							
							{ item.templates.map( (e,x) => 
								<Link id={`editor${i}${x}`} key={x} to={`/editor/${i}/${x}`}>
									
									<div class="Placeholder" style={{ aspectRatio: `${item.specs.width}/${ e.height ? e.height : item.specs.height }` }}>
										{ e.placeholder &&
											<img src={`/themes/${e.placeholder}`} />
										}
										{ !e.placeholder &&
											<div>{ item.specs.width } x { e.height ? e.height : item.specs.height }</div>
										}
									</div>
									<p>{ e.label }</p>
								</Link>
							)}
						</div>
						<div>
							{ item.templates.length > 2 &&
								<ul>
									<li><a href={`#editor${i}${0}`}>&#10229;</a></li>
									<li><a href={`#editor${i}${item.templates.length - 1}`}>&#10230;</a></li>
								</ul>
							}
						</div>
					</div>
				)}
			</div>
		</div>
	);
}

export default List;